module.exports = __webpack_public_path__ + "bd09e17cd0fd6757d6d02c45f97131a1.jpg";